module.exports = __webpack_public_path__ + "img/lg_ring_g_e_0_1.c901be3f.png";